import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';

import {
  PM_RESULT_OF_INSPECTION,
  PM_SUBJECT,
  PM_EVENTS,
  ORGANIZATION_FOR_SELECT,
  KNM_NOTIFICATION,
} from '../../../CorePackage/MainModule/routes/routes';
import {
  getNotificationBlockId,
  getObjectBlockId,
  getObjectKindBlockId,
  getObjectManualAddressBlockId,
  getObjectNameBlockId,
  getObjectPMAddressBlockId,
  getObjectRegionBlockId,
  getObjectRiskCategoryBlockId,
  getObjectSubKindBlockId,
  getObjectTypeBlockId,
  getPmRejectBlockId,
} from '../../../KnmPackage/MainModule/constants/fieldsElementsIds';
import { KnmPmFormFieldsNamesTemplatesEnum } from '../enums/KnmPmFormFieldsNamesTemplatesEnum';
import {
  COLLABORATING_ORGANIZATIONS_BLOCK_ID,
  CONTENT_WARNING_BLOCK_ID,
  COUNTRY_BLOCK_ID,
  DOCUMENT_BLOCK_ID,
  HAS_NOTIFICATIONS_BLOCK_ID,
  INN_LABEL_BLOCK_ID,
  INSPECTORS_BLOCK_ID,
  IS_REJECT_SUBJECT_BLOCK_ID,
  KNO_ORGANIZATION_BLOCK_ID,
  KPP_BLOCK_ID,
  LOCATION_BLOCK_ID,
  NOTE_WARNING_BLOCK_ID,
  OBJECTION_WARNING_BLOCK_ID,
  OBJECTS_BLOCK_ID,
  OGRN_LABEL_BLOCK_ID,
  OKVEDS_BLOCK_ID,
  ORGANIZATION_NAME_BLOCK_ID,
  PM_FORM_BLOCK_ID,
  PM_TYPE_BLOCK_ID,
  RAFP_NZA_BLOCK_ID,
  REASONS_BLOCK_ID,
  SNILS_BLOCK_ID,
  PM_RESULT_DECISIONS_BLOCK_ID,
  START_DATE_BLOCK_ID,
  STOP_DATE_BLOCK_ID,
  SUPERVISION_TYPE_BLOCK_ID,
  getCollaboratingOrganizationBlockId,
  getInspectorBlockId,
  getOkvedBlockId,
  getReasonBlockId,
  getRequirementsNpaBlockId,
  getPmResultDecisionsBlockId,
  getPmResultDecisionsSignerBlockId,
  getEventBlockId,
  IS_UNABLE_TO_REFUSE_BLOCK_ID,
  EXTENSION_BLOCK_ID,
  MANUAL_ADDRESS_BLOCK_ID,
  REGION_BLOCK_ID,
  REQUIREMENTS_NPA_BLOCK_ID,
  OFFICIAL_FULL_NAME_BLOCK_ID,
  PM_SIGNER_POSITION_BLOCK_ID,
  ABROGATION_LINK_BLOCK_ID,
  ABROGATION_REASON_ID_BLOCK_ID,
  DOC_TARGET_BLOCK_ID,
  getApproveDocBlockId,
  getReschedulingBlockId,
  getComplexDataBlockId,
  getRiskIndicatorsBlockId,
  getPeriodSuspensionEventBlockAttachmentsId,
  getPeriodSuspensionEventBlockEventId,
  getPeriodSuspensionEventBlockDecisionDateTimeId,
  getPeriodSuspensionEventBlockDecisionNumberId,
  getPeriodSuspensionEventBlockStartDateId,
  getPeriodSuspensionEventBlockStopDateId,
  EXPERTS_BLOCK_ID,
  getExpertBlockId,
  PM_ACT_BLOCK_ID,
  PM_TAKEN_MEASURES_BLOCK_ID,
  getVideoCallInfoBlockId,
  VIDEO_CALL_INFO_WRAPPER_BLOCK_ID,
  NOTE_WARNING_REACT_QUILL_EDITOR_BLOCK_ID,
  getAgreementsBlockId,
  PM_SIGNERS_BLOCK_ID,
  getPmSignersSignerFioBlockId,
  getPmSignersSignerPositionBlockId,
} from './knmPmFieldsElementsIds';
import { KnmErknmFormFieldsNamesTemplatesEnum } from '../../../KnmErknmPackage/MainModule/enums/KnmErknmFormFieldsNamesTemplatesEnum';

interface IFieldData {
  title: string;
  getScrollElementId: (id?: string) => string;
  getReserveScrollElementId?: (id?: string) => string;
}

export const knmPmFieldsDataByFlatNameMap = (
  created: string | null | undefined,
  settings: IAdminSetting[] | undefined,
): Record<KnmPmFormFieldsNamesTemplatesEnum[number], IFieldData> => {
  const isEnablePaperlessPassportDocument = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM,
  );

  return {
    [KnmPmFormFieldsNamesTemplatesEnum.OFFICIAL_FULL_NAME]: {
      title: 'ФИО должностного лица',
      getScrollElementId: () => OFFICIAL_FULL_NAME_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_SIGNER_POSITION]: {
      title: 'Должность лица, подписавшего паспорт ПМ',
      getScrollElementId: () => PM_SIGNER_POSITION_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SIGNERS]: {
      title: 'Подписанты',
      getScrollElementId: () => PM_SIGNERS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SIGNERS_SIGNER_FIO]: {
      title: 'Подписанты - ФИО должностного лица',
      getScrollElementId: (id: string) => getPmSignersSignerFioBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SIGNERS_SIGNER_POSITION]: {
      title: 'Подписанты - Должность лица, подписавшего паспорт ПМ',
      getScrollElementId: (id: string) => getPmSignersSignerPositionBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.MANUAL_ADDRESS]: {
      title: 'Место проведения профилактического мероприятия - Адрес',
      getScrollElementId: () => MANUAL_ADDRESS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REGION]: {
      title: 'Место проведения профилактического мероприятия - Регион',
      getScrollElementId: () => REGION_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_START_DATE_ID]: {
      title: 'Сведения о переносе мероприятия - Новая дата начала ПМ',
      getScrollElementId: (id: string) => getReschedulingBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_END_DATE_ID]: {
      title: 'Сведения о переносе мероприятия - Новая дата окнчания ПМ',
      getScrollElementId: (id: string) => getReschedulingBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_DURATION_DAYS_ID]: {
      title: 'Сведения о переносе мероприятия - новый срок непосредственного взаимодействия (дней)',
      getScrollElementId: (id: string) => getReschedulingBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_DURATION_HOURS_ID]: {
      title: 'Сведения о переносе мероприятия - новый срок непосредственного взаимодействия (часов)',
      getScrollElementId: (id: string) => getReschedulingBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ABROGATION_REASON_ID]: {
      title: 'Сведения об отмене мероприятия - Основание для отмены',
      getScrollElementId: () => ABROGATION_REASON_ID_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ABROGATION_LINK]: {
      title: 'Сведения об отмене мероприятия - Ссылка на профилактический визит',
      getScrollElementId: () => ABROGATION_LINK_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.KNO_ORGANIZATION]: {
      title: 'Контрольный (надзорный) орган',
      getScrollElementId: () => KNO_ORGANIZATION_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUPERVISION_TYPE]: {
      title: 'Вид государственного контроля (надзора)',
      getScrollElementId: () => SUPERVISION_TYPE_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_TYPE]: {
      title: 'Вид профилактического мероприятия',
      getScrollElementId: () => PM_TYPE_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.START_DATE]: {
      title: 'Дата начала',
      getScrollElementId: () => START_DATE_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.STOP_DATE]: {
      title: 'Дата окончания',
      getScrollElementId: () => STOP_DATE_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_FORM]: {
      title: 'Форма проведения профилактического мероприятия',
      getScrollElementId: () => PM_FORM_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_FULLNAME]: {
      title: 'ФИО должностного лица',
      getScrollElementId: () => PM_FORM_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_POSITION_SIGNER]: {
      title: 'Должность лица, подписавшего паспорт ПМ',
      getScrollElementId: () => PM_FORM_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ORGANIZATION_FOR_SELECT]: {
      title: 'Сведения о контролируемом лице',
      getScrollElementId: () => ORGANIZATION_FOR_SELECT,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.LOCATION]: {
      title: 'Место проведения профилактического мероприятия',
      getScrollElementId: () => LOCATION_BLOCK_ID,
    },

    [KnmPmFormFieldsNamesTemplatesEnum.EXTENSION_ATTACHMENT]: {
      title: 'Сведения о продлении срока проведения ПМ - Файл решения',
      getScrollElementId: () => EXTENSION_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EXTENSION_DATE]: {
      title: 'Сведения о продлении срока проведения ПМ - Дата и время решения',
      getScrollElementId: () => EXTENSION_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EXTENSION_NUMBER]: {
      title: 'Сведения о продлении срока проведения ПМ- Номер решения',
      getScrollElementId: () => EXTENSION_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EXTENSION_AMOUNT]: {
      title: 'Сведения о продлении срока проведения ПМ - Продление срока проведения ПМ',
      getScrollElementId: () => EXTENSION_BLOCK_ID,
    },

    [KnmPmFormFieldsNamesTemplatesEnum.SUSPENSION_ATTACHMENT]: {
      title: 'Сведения о приостановлении срока проведения ПМ - Файл решения',
      getScrollElementId: getPeriodSuspensionEventBlockAttachmentsId,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUSPENSION_EVENT]: {
      title: 'Сведения о приостановлении срока проведения ПМ - Действие',
      getScrollElementId: getPeriodSuspensionEventBlockEventId,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUSPENSION_DATE]: {
      title: 'Сведения о приостановлении срока проведения ПМ - Дата и время решения',
      getScrollElementId: getPeriodSuspensionEventBlockDecisionDateTimeId,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUSPENSION_NUMBER]: {
      title: 'Сведения о приостановлении срока проведения ПМ- Номер решения',
      getScrollElementId: getPeriodSuspensionEventBlockDecisionNumberId,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUSPENSION_START_DATE]: {
      title: 'Сведения о приостановлении срока проведения ПМ - Дата начала приостановления срока ПМ',
      getScrollElementId: getPeriodSuspensionEventBlockStartDateId,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUSPENSION_STOP_DATE]: {
      title: 'Сведения о приостановлении срока проведения ПМ - Дата окончания приостановления срока ПМ',
      getScrollElementId: getPeriodSuspensionEventBlockStopDateId,
    },

    [KnmPmFormFieldsNamesTemplatesEnum.NOTE_WARNING]: {
      title: 'Описание предостережения',
      getScrollElementId: () => NOTE_WARNING_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.CONTENT_WARNING]: {
      title: 'Содержание предостережения',
      getScrollElementId: () => CONTENT_WARNING_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECTION_WARNING]: {
      title: 'Сведения о направлении возражения на предостережение',
      getScrollElementId: () => OBJECTION_WARNING_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASONS]: {
      title: 'Основание проведения ПМ',
      getScrollElementId: () => REASONS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.IS_PRESENT_IN_IT_REGISTRY]: {
      title: 'Наличие в реестре аккредитованных IT-организаций',
      getScrollElementId: () => PM_SUBJECT,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.DOC_TARGET]: {
      title: 'Разрешительные и иные документы',
      getScrollElementId: () => DOC_TARGET_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.DOC_TARGET_ITEM]: {
      title: 'Разрешительные и иные документы',
      getScrollElementId: () => DOC_TARGET_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.DOC_TARGET_ITEM_DOC_TARGET_TYPE]: {
      title: 'Разрешительные и иные документы - Тип документа',
      getScrollElementId: () => DOC_TARGET_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.DOC_TARGET_ITEM_ERVK_CONTROL_KIND_DOC_TARGET]: {
      title: 'Разрешительные и иные документы',
      getScrollElementId: () => DOC_TARGET_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENTS]: {
      title: 'Перечень действий, осуществляемых в рамках ПМ',
      getScrollElementId: () => PM_EVENTS,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON]: {
      title: 'Основание проведения профилактических мероприятий',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_TYPE]: {
      title: 'Основания проведения профилактических мероприятий',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_LINK]: {
      title: 'Основание проведения ПМ - Ссылка на другой паспорт КНМ или ПМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_LINK_VALIDATION]: {
      title: 'Основание проведения ПМ - Ссылка на другой паспорт КНМ или ПМ',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_TEXT]: {
      title: 'Основание проведения ПМ - Дополнительно',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_DATE]: {
      title: 'Основание проведения ПМ - Дата основания проведения профилактических мероприятий',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_PLAN_KNM]: {
      title: 'Основание проведения ПМ - Плановое КНМ, взамен которого проводится профилактическое мероприятие',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_DATE_REQUIREMENT]: {
      title: 'Основание проведения ПМ - Дата требования проведения профилактических мероприятий',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_NUMBER]: {
      title: 'Основание проведения ПМ - Номер поручения',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_ORDER]: {
      title: 'Основание проведения ПМ - Номер поручения',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_DATE]: {
      title: 'Основание проведения ПМ - Дата поручения',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_ASSIGNMENT_FULLNAME]: {
      title: 'Основание проведения ПМ - ФИО лица, издавшего поручение',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_REQUIREMENT_DETAILS]: {
      title: 'Основание проведения ПМ - Реквизиты требования',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATORS_VALUE]: {
      title: 'Основание проведения ПМ - Индикатор риска',
      getScrollElementId: (id: string) => getRiskIndicatorsBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_VALUE]: {
      title: 'Основание проведения ПМ - Индикатор риска',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR]: {
      title: 'Основание проведения ПМ - Индикатор риска',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_AUTO]: {
      title: 'Основание проведения ПМ - Индикатор риска - Индикатор риска срабатывает в автоматическом режиме',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_FILE]: {
      title: 'Основание проведения ПМ - Индикатор риска - Файл индикатора риска',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_LAST_CONDUCTED_KNM_DATE]: {
      title: 'Основание проведения ПМ - Дата',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_PROGRAM_NUMBER]: {
      title: 'Основание проведения ПМ - Номер программы проверок',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REASON_PROGRAM_ATTACHMENT]: {
      title: 'Основание проведения ПМ - Файл программы проверок',
      getScrollElementId: (id: string) => getReasonBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_TYPE]: {
      title: 'Действие',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_INTERACTION_CATEGORY]: {
      title: 'Категория взаимодействия',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_START_DATE]: {
      title: 'Дата начала действия',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_STOP_DATE]: {
      title: 'Дата окончания действия',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS]: {
      title: 'Перечень действий - Представляемые документы',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_TITLE_ID]: {
      title: 'Перечень действий - Представляемые документы - Наименование',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_REQUEST_DATETIME_ID]: {
      title: 'Перечень действий - Представляемые документы - Дата и время запроса',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_DEADLINE_ID]: {
      title: 'Перечень действий - Представляемые документы - Срок представления',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_FILE_ID]: {
      title: 'Перечень действий - Представляемые документы - Файл',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_SUBMITTED_DOCUMENTS_SUBMISSION_DATETIME_ID]: {
      title: 'Перечень действий - Представляемые документы - Дата и время получения документа',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_UAV_TECHNOLOGIES]: {
      title: 'Перечень действий - Сведения об использовании беспилотных технологий',
      getScrollElementId: (id: string) => getEventBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_UAV_TECHNOLOGIES_TYPE]: {
      title: 'Перечень действий - Вид беспилотника',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EVENT_UAV_TECHNOLOGIES_NAME]: {
      title: 'Перечень действий - Название беспилотника',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.INN]: {
      title: 'Идентификационный номер налогоплательщика (ИНН)',
      getScrollElementId: () => INN_LABEL_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OGRN]: {
      title: 'Основной государственный регистрационный номер (ОГРН)',
      getScrollElementId: () => OGRN_LABEL_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ORGANIZATION_NAME]: {
      title: 'Наименование проверяемого лица',
      getScrollElementId: () => ORGANIZATION_NAME_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OKVEDS]: {
      title: 'Список ОКВЭД',
      getScrollElementId: () => OKVEDS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OKVED]: {
      title: 'ОКВЭД',
      getScrollElementId: (id: string) => getOkvedBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OKVED_OKVED]: {
      title: 'ОКВЭД',
      getScrollElementId: (id: string) => getOkvedBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SNILS]: {
      title: 'Страховой номер индивидуального лицевого счета (СНИЛС)',
      getScrollElementId: () => SNILS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.IS_SONKO_REGISTRY]: {
      title: 'Наличие проверяемого лица в реестре СОНКО',
      getScrollElementId: () => 'isSonko',
    },
    [KnmPmFormFieldsNamesTemplatesEnum.IS_MSP_REGISTRY]: {
      title: 'Наличие проверяемого лица в реестре МСП',
      getScrollElementId: () => 'mspCode',
    },
    [KnmPmFormFieldsNamesTemplatesEnum.IS_NKO_REGISTRY]: {
      title: 'Наличие проверяемого лица в реестре МСП',
      getScrollElementId: () => 'isNko',
    },
    [KnmPmFormFieldsNamesTemplatesEnum.DOCUMENT]: {
      title: 'Сведения о документе, удостоверяющем личность',
      getScrollElementId: () => DOCUMENT_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.COUNTRY]: {
      title: 'Государство, в котором указанное лицо зарегистрировано',
      getScrollElementId: () => COUNTRY_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.RAFP_NZA]: {
      title: 'Номер записи об аккредитации в РАФП',
      getScrollElementId: () => RAFP_NZA_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.KPP]: {
      title: 'Код причины постановки на учет (КПП)',
      getScrollElementId: () => KPP_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECTS]: {
      title: 'Сведения об объектах контроля',
      getScrollElementId: () => OBJECTS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECT]: {
      title: 'Объект проведения КНМ',
      getScrollElementId: (id: string) => getObjectBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_NAME]: {
      title: 'Наименование объекта проведения',
      getScrollElementId: (id: string) => getObjectNameBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECT_ADDRESS]: {
      title: 'Местонахождение объекта проведения',
      getScrollElementId: (id: string) => getObjectPMAddressBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_TYPE]: {
      title: 'Тип объекта проведения',
      getScrollElementId: (id: string) => getObjectTypeBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_KIND]: {
      title: 'Вид объекта проведения',
      getScrollElementId: (id: string) => getObjectKindBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_SUB_KIND]: {
      title: 'Подвид объекта проведения',
      getScrollElementId: (id: string) => getObjectSubKindBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECT_RISK_CATEGORY]: {
      title: 'Категория риска объекта проведения',
      getScrollElementId: (id: string) => getObjectRiskCategoryBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECT_REGION]: {
      title: 'Регион местонахождения объекта проведения',
      getScrollElementId: (id: string) => getObjectRegionBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.OBJECT_MANUAL_ADDRESS]: {
      title: 'Адрес местонахождения объекта проведения',
      getScrollElementId: (id: string) => getObjectManualAddressBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.INSPECTORS]: {
      title:
        'Сведения о должностных лицах контрольных (надзорных) органов, участвующих в соответствующих профилактических мероприятиях',
      getScrollElementId: () => INSPECTORS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.INSPECTOR]: {
      title: 'Должностное лицо, участвующее в соответствующих профилактических мероприятиях',
      getScrollElementId: (id: string) => getInspectorBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.INSPECTOR_FULL_NAME]: {
      title: 'ФИО должностного лица, участвующего в соответствующих профилактических мероприятиях',
      getScrollElementId: (id: string) => getInspectorBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.INSPECTOR_POSITION]: {
      title: 'Должность должностного лица, участвующего в соответствующих профилактических мероприятиях',
      getScrollElementId: (id: string) => getInspectorBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EXPERTS]: {
      title:
        'Сведения об экспертах, экспертных организациях, специалистах, независимых органах инспекции, саморегулируемых организациях и иных лицах, привлекаемых для проведения ПМ',
      getScrollElementId: () => EXPERTS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EXPERT]: {
      title: 'Эксперт',
      getScrollElementId: (id: string) => getExpertBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EXPERT_TITLE]: {
      title: 'Наименование эксперта',
      getScrollElementId: (id: string) => getExpertBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.EXPERT_TYPE]: {
      title: 'Тип эксперта',
      getScrollElementId: (id: string) => getExpertBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS]: {
      title: 'Список КНО, с которыми ПМ проводится совместно',
      getScrollElementId: () => COLLABORATING_ORGANIZATIONS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM]: {
      title: 'Наименование КНО с которым ПМ проводится совместно',
      getScrollElementId: (id: string) => getCollaboratingOrganizationBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM_ORGANIZATION]: {
      title: 'Наименование КНО с которым ПМ проводится совместно',
      getScrollElementId: (id: string) => getCollaboratingOrganizationBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM_TITLE]: {
      title: 'Наименование КНО с которым ПМ проводится совместно',
      getScrollElementId: (id: string) => getCollaboratingOrganizationBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.IS_HAS_NOTIFICATION]: {
      title: 'Информация об уведомлении проверяемого лица о проведении ПМ',
      getScrollElementId: () => HAS_NOTIFICATIONS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.IS_REJECT_SUBJECT]: {
      title: 'Информация о несогласии контролируемого лица на проведение мероприятия',
      getScrollElementId: () => IS_REJECT_SUBJECT_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.RESULT_OF_INSPECTION]: {
      title: 'Сведения о результатах профилактического мероприятия ',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA]: {
      title: 'Обязательные требования, подлежащие проверке',
      getScrollElementId: () => REQUIREMENTS_NPA_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_ITEM]: {
      title: 'Обязательные требования, подлежащие проверке',
      getScrollElementId: (id: string) => getRequirementsNpaBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_MANDATORY]: {
      title: 'Содержания обязательных требований, подлежащих проверке',
      getScrollElementId: (id: string) => getRequirementsNpaBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_MANDATORY_ITEM]: {
      title: 'Содержания обязательных требований, подлежащих проверке',
      getScrollElementId: (id: string) => getRequirementsNpaBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.APPROVE_DOC_ITEM]: {
      title: 'Разрешительный или иной документ',
      getScrollElementId: (id: string) => getApproveDocBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.IS_ORGANIZATION_NEW]: {
      title: 'Сведения о контролируемом лице',
      getScrollElementId: () => PM_SUBJECT,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUBJECT_TYPE_PM]: {
      title: 'Тип контролируемого лица',
      getScrollElementId: () => PM_SUBJECT,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUBJECT_ADDRESS]: {
      title: 'Адрес места нахождения',
      getScrollElementId: () => PM_SUBJECT,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUBJECT_MANUAL_ADDRESS]: {
      title: 'Адрес места нахождения - не из ФИАС',
      getScrollElementId: () => PM_SUBJECT,
    },
    [KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATIONS_FIAS_REGION]: {
      title: 'Адрес места нахождения - Субъект РФ',
      getScrollElementId: () => PM_SUBJECT,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.NOTIFICATION_DATE]: {
      title: `${isEnablePaperlessPassportDocument ? 'Уведомление о решении' : 'Информация об уведомлении'} - Дата`,
      getScrollElementId: (id: string) => getNotificationBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.NOTIFICATION_TYPE]: {
      title: `${
        isEnablePaperlessPassportDocument ? 'Уведомление о решении' : 'Информация об уведомлении'
      } - Способ уведомления`,
      getScrollElementId: (id: string) => getNotificationBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.NOTIFICATION_COMMENT]: {
      title: `${
        isEnablePaperlessPassportDocument ? 'Уведомление о решении' : 'Информация об уведомлении'
      } - Примечание`,
      getScrollElementId: (id: string) => getNotificationBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REJECT_DATE]: {
      title: 'Информация о непроведении - Дата выявления причины',
      getScrollElementId: (id: string) => getPmRejectBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.REJECT_CANCELED_REASON]: {
      title: 'Информация о непроведении - Причина непроведения профилактического мероприятия',
      getScrollElementId: (id: string) => getPmRejectBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISIONS]: {
      title: 'Сведения о решениях, принятых по результатам ПМ',
      getScrollElementId: () => PM_RESULT_DECISIONS_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION]: {
      title: 'Сведения о решениях, принятых по результатам ПМ',
      getScrollElementId: (id: string) => getPmResultDecisionsBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_DECISION_NUMBER]: {
      title: 'Сведения о решении - Номер решения',
      getScrollElementId: (id: string) => getPmResultDecisionsBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_DECISION_DATE]: {
      title: 'Сведения о решении - Дата издания решения',
      getScrollElementId: (id: string) => getPmResultDecisionsBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FILE]: {
      title: 'Сведения о решении - Документ решения',
      getScrollElementId: (id: string) => getPmResultDecisionsBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_KIND_DECISION]: {
      title: 'Сведения о решении - Вид решения',
      getScrollElementId: (id: string) => getPmResultDecisionsBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_DEADLINE]: {
      title: 'Сведения о решении - Срок исполнения решения',
      getScrollElementId: (id: string) => getPmResultDecisionsBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_INFORMATION]: {
      title:
        'Сведения о решении - Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям"',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.information`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_SIGNER_FULL_NAME]: {
      title: 'Сведения о решении - ФИО должностного лица',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.signerFullName`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_SIGNER_POSITION]: {
      title: 'Сведения о решении - Должность',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.signerPosition`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_SIGNERS]: {
      title: 'Сведения о решении - Подписанты',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.signers`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_SIGNERS_SIGNER_FULL_NAME]: {
      title: 'Сведения о решении - Подписанты - ФИО должностного лица',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_SIGNERS_POSITION]: {
      title: 'Сведения о решении - Подписанты - Должность подписанта',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_SUBJECT_TYPE_PM]: {
      title: 'Сведения о решении - Тип учередителя',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_INN]: {
      title: 'Сведения о решении - Идентификационный номер налогоплательщика (ИНН)',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_OGRN]: {
      title: 'Сведения о решении - Основной государственный регистрационный номер (ОГРН)',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_ORGANIZATION_NAME]: {
      title: 'Сведения о решении - Наименование проверяемого лица',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_OKVEDS]: {
      title: 'Сведения о решении - Список ОКВЭД',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.$organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_OKVED]: {
      title: 'Сведения о решении - ОКВЭД',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.$organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_OKVED_OKVED]: {
      title: 'Сведения о решении - ОКВЭД',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.$organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_SNILS]: {
      title: 'Сведения о решении - Страховой номер индивидуального лицевого счета (СНИЛС)',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.$organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_DOCUMENT]: {
      title: 'Сведения о решении - Сведения о документе, удостоверяющем личность',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.$organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_COUNTRY]: {
      title: 'Сведения о решении - Государство, в котором указанное лицо зарегистрировано',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.$organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_RAFP_NZA]: {
      title: 'Сведения о решении - Номер записи об аккредитации в РАФП',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.$organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_FOUNDER_KPP]: {
      title: 'Сведения о решении - Код причины постановки на учет (КПП)',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.$organizationBlock`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_IS_VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Результаты мероприятия - Выявленные нарушенные обязательные требования',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_VIOLATED_REQUIREMENTS]: {
      title: 'Результаты мероприятия - Выявленные нарушения обязательных требований',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATIONS]: {
      title: 'Результаты мероприятия - Нарушения обязательных требований',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE]: {
      title: 'Результаты мероприятия - Нарушения обязательных требований',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED_ON_PLACE]: {
      title: 'Результаты мероприятия - Нарушения обязательных требований',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED]: {
      title: 'Результаты мероприятия - Нарушения обязательных требований',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Результаты мероприятия - Нарушенные обязательные требования',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM]: {
      title: 'Результаты мероприятия - Содержание требования',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_CATEGORY]: {
      title: 'Результаты мероприятия - Значимость последствий нарушения',
      getScrollElementId: () => PM_RESULT_OF_INSPECTION,
    },

    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY]: {
      title: 'Сведения о решении - Устраняемые нарушения обязательных требований',
      getScrollElementId: (resultDecisionId: string) => getPmResultDecisionsSignerBlockId(resultDecisionId),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATIONS]: {
      title: 'Сведения о решении - Нарушения обязательных требований',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIXED_ON_PLACE]: {
      title: 'Сведения о решении - Нарушение устранено в ходе мероприятия',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIXED]: {
      title: 'Сведения о решении - Нарушение устранено',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_PLAN_EXPLANATIONS]: {
      title: 'Сведения о решении - Пояснение инспектора к устранению',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_PLAN_EXPLANATIONS_REQUIRED]: {
      title: 'Сведения о решении - Пояснение инспектора к устранению',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATES]: {
      title: 'Сведения о решении - Плановая дата устранения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATES_REQUIRED]: {
      title: 'Сведения о решении - Плановая дата устранения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATE]: {
      title: 'Сведения о решении - Плановая дата устранения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHODS]: {
      title: 'Сведения о решении - Планируемый способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHODS_REQUIRED]: {
      title: 'Сведения о решении - Планируемый способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION]: {
      title: 'Сведения о решении - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FACT_METHOD]: {
      title: 'Сведения о решении - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHOD]: {
      title: 'Сведения о решении - Планируемый способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    // [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_EXPLANATION]: {
    //   title: 'Сведения о решении - Пояснение инспектора к устранению',
    //   getScrollElementId: (id: string) => getComplexDataBlockId(id),
    // },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Сведения о решении - Пояснение инспектора к устранению',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPES]: {
      title: 'Сведения о решении - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE]: {
      title: 'Сведения о решении - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    // [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE_EXPLANATION]: {
    //   title: 'Сведения о решении - Пояснение к материалу',
    //   getScrollElementId: (id: string) => getComplexDataBlockId(id),
    // },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Сведения о решении - Пояснение к материалу',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },

    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_METHOD]: {
      title: 'Сведения о решении - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FILES]: {
      title: 'Сведения о решении - Файлы устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FILES_VIDEO_LINK]: {
      title: 'Сведения о решении - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_GRADE]: {
      title: 'Сведения о решении - Оценка исправления нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS]: {
      title: 'Сведения о решении - Уведомление',
      getScrollElementId: (id: string) => `${getPmResultDecisionsBlockId(id)}.familiarizationNotifications`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_TYPE]: {
      title: 'Сведения о решении - Способ уведомления',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE]: {
      title: 'Сведения о решении - Дата уведомления',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTE]: {
      title: 'Сведения о решении - Примечание',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.IS_UNABLE_TO_REFUSE]: {
      title: 'Должен быть проставлен признак «Обязательный профилактический визит»',
      getScrollElementId: () => IS_UNABLE_TO_REFUSE_BLOCK_ID,
    },

    [KnmPmFormFieldsNamesTemplatesEnum.ACT]: {
      title: 'Акт',
      getScrollElementId: () => PM_ACT_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_CREATION_ACT_DATE_TIME]: {
      title: 'Акт - Дата и время составления акта ПМ',
      getScrollElementId: () => PM_ACT_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTORS]: {
      title: 'Акт - Должностные лица контрольного (надзорного) органа, участвовавшие в ПМ',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.knoInspectors`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR]: {
      title: 'Акт - Должностное лицо контрольного (надзорного) органа, участвовавшие в ПМ',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.knoInspectors`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_KNO_INSPECTOR]: {
      title: 'Акт - Должностное лицо контрольного (надзорного) органа, участвовавшие в ПМ',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_FULL_NAME]: {
      title: 'Акт - ФИО должностного лица контрольного (надзорного) органа, участвовавшего в ПМ',
      getScrollElementId: () => PM_ACT_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_POSITION]: {
      title: 'Акт - Должность должностного лица контрольного (надзорного) органа, участвовавшего в ПМ',
      getScrollElementId: () => PM_ACT_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_ACQUAINTANCE_TYPE]: {
      title: 'Акт - Сведения об ознакомлении контролируемых лиц с результатами ПМ',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.acquaintanceType`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_ACQUAINTANCE_LACK_TYPE]: {
      title: 'Акт - Сведения об ознакомлении контролируемых лиц с результатами ПМ - Причина неознакомления',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.acquaintanceLackType`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_FIO_READER]: {
      title: 'Акт - Сведения об ознакомлении контролируемых лиц с результатами ПМ - Кто ознакомлен',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.fioReader`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_TITLE_READER]: {
      title: 'Акт - Сведения об ознакомлении контролируемых лиц с результатами ПМ - Должность',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.titleReader`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_REFUSER_FIO]: {
      title: 'Акт - Сведения об ознакомлении контролируемых лиц с результатами ПМ - Кто отказал',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.refuserFio`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_REFUSER_TITLE]: {
      title: 'Акт - Сведения об ознакомлении контролируемых лиц с результатами ПМ - Должность отказавшего',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.refuserTitle`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_DURATION_DAYS]: {
      title: 'Акт - Срок проведения (в днях)',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.durationDays`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_DURATION_HOURS]: {
      title: 'Акт - Срок проведения (в часах)',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.durationHours`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_TYPE_ACT]: {
      title: 'Акт - Вид акта',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.typeAct`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON]: {
      title: 'Акт - Причина невозможности проведения',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.canceledReason`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON_DESCRIPTION]: {
      title: 'Акт - Описание причины невозможности проведения',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.canceledReasonDescription`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON_DESCRIPTION_REACT_QUILL_EDITOR]: {
      title: 'Акт - Описание причины невозможности проведения',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.canceledReasonDescription`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_DOCUMENTS_ATTACHMENTS]: {
      title: 'Акт - Файл акта',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.document.attachments`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_FIO_AND_POSITION_SIGNER]: {
      title: 'ФИО и должность лица, подписавшего акт',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.fioAndPositionSinger`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_FIO_SIGNER]: {
      title: 'Акт - ФИО подписавшего акт',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.fioSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_TITLE_SIGNER]: {
      title: 'Акт - Должность лица, подписавшего акт',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.titleSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_SIGNERS]: {
      title: 'Акт - Подписанты',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.signers`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_SIGNERS_FIO_SIGNER]: {
      title: 'Акт - Подписанты - ФИО подписавшего акт',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_SIGNERS_TITLE_SIGNER]: {
      title: 'Акт - Подписанты - Должность лица, подписавшего акт',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_IS_VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Акт - Наличие обязательных требований',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.isViolatedMandatoryRequirements`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS]: {
      title: 'Акт - Нарушенные обязательные требования',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.isViolatedMandatoryRequirements`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_FAMILIARIZATION_NOTIFICATIONS]: {
      title: 'Акт - Уведомление',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.familiarizationNotifications`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_FAMILIARIZATION_NOTIFICATIONS_TYPE]: {
      title: 'Акт - Способ уведомления',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE]: {
      title: 'Акт - Дата уведомления',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_FAMILIARIZATION_NOTIFICATIONS_NOTE]: {
      title: 'Акт - Примечание',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_REMARKS_TEXT]: {
      title: 'Акт - Замечание - Текст замечания',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_REMARKS_TEXT_REACT_QUILL_EDITOR]: {
      title: 'Акт - Замечание - Текст замечания',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_REMARKS_SIGNER_FULLNAME]: {
      title: 'Акт - Замечание - ФИО лица, оставившего замечание',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_REMARKS_SIGNER_POSITION]: {
      title: 'Акт - Замечание - Должность лица, оставившего замечание',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_REMARKS_DATE]: {
      title: 'Акт - Замечание - Дата',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE]: {
      title: 'Акт - Описание нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED_ON_PLACE]: {
      title: 'Акт - Нарушение устранено в ходе мероприятия',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATIONS]: {
      title: 'Акт - Нарушения обязательных требований',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED]: {
      title: 'Акт - Нарушение устранено',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES_VIDEO_LINK]: {
      title: 'Акт - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_EVENTS]: {
      title: 'Акт - Нарушение - Осуществленное действие',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_EVENT]: {
      title: 'Акт - Нарушение - Осуществленное действие',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_EVENT_MATERIALS]: {
      title: 'Акт - Нарушение - Сведения о фиксации нарушений',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_EVENT_MATERIAL_TYPE]: {
      title: 'Акт - Нарушение - Сведения о фиксации нарушений - Тип материала',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_EVENT_MATERIAL_LINKS]: {
      title: 'Акт - Нарушение - Сведения о фиксации нарушений - Ссылки на документ',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_EVENT_MATERIAL_LINK]: {
      title: 'Акт - Нарушение - Сведения о фиксации нарушений - Ссылка на документ',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_EVENT_MATERIAL_ATTACHMENTS]: {
      title: 'Акт - Нарушение - Сведения о фиксации нарушений - Файлы',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES]: {
      title: 'Акт - Файлы устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION]: {
      title: 'Акт - Сведения о факте устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPES]: {
      title: 'Акт - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE]: {
      title: 'Акт - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_METHOD]: {
      title: 'Акт - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => id,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE_REACT_QUILL_EDITOR]: {
      title: 'Акт - Описание нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY]: {
      title: 'Акт - Нарушенные обязательные требования',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM]: {
      title: 'Акт - Содержание требования',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_CATEGORY]: {
      title: 'Акт - Значимость последствий нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENTS]: {
      title: 'Акт - Перечень осуществляемых действий',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.events`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT]: {
      title: 'Акт - Перечень осуществляемых действий',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.events`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_INVOLVED_EXPERTS]: {
      title: 'Акт - Привлеченные эксперты',
      getScrollElementId: (actId: string) => getComplexDataBlockId(actId),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_INVOLVED_WITNESSES_VALUE]: {
      title: 'Акт - Привлеченные к проверке свидетели',
      getScrollElementId: (actId: string) => getComplexDataBlockId(actId),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_TYPE]: {
      title: 'Акт - Тип действия, осуществляемого в рамках ПМ',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTORS]: {
      title: 'Акт - Должностное лицо, осуществившее действие',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTOR_FULL_NAME]: {
      title: 'Акт - Должностное лицо, осуществившее действие',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_START_DATE]: {
      title: 'Акт - Дата начала действия, осуществляемого в рамках ПМ',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_STOP_DATE]: {
      title: 'Акт - Дата окончания действия, осуществляемого в рамках ПМ',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VKS]: {
      title: 'Акт - Ссылка на ВКС',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VIDEO]: {
      title: 'Акт - Ссылка на видеозапись',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES]: {
      title: 'Акт - Сведения об использовании беспилотных технологий',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES_TYPE]: {
      title: 'Акт - Вид беспилотника',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES_NAME]: {
      title: 'Акт - Название беспилотника',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_PROTOCOL_FILE_ATTACHMENTS]: {
      title: 'Акт - Файл протокола',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_NUMBER_ACT]: {
      title: 'Акт - Номер акта ПМ',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.numberAct`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.ACT_HOLDING_DATE_TIME]: {
      title: 'Акт - Дата и время начала проведения ПМ',
      getScrollElementId: () => `${PM_ACT_BLOCK_ID}.holdingDateTime`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.TAKEN_MEASURES]: {
      title: 'Предложенные меры',
      getScrollElementId: () => PM_TAKEN_MEASURES_BLOCK_ID,
    },
    // [KnmPmFormFieldsNamesTemplatesEnum.TAKEN_MEASURES_VALUE]: {
    //   title: 'Принятые меры знач',
    //   getScrollElementId: (id: string) => getTakenMeasuresValueBlockId(id),
    // },
    [KnmPmFormFieldsNamesTemplatesEnum.VIDEO_CALL_INFO]: {
      title: 'Видео-конференц-связь',
      getScrollElementId: () => VIDEO_CALL_INFO_WRAPPER_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.VIDEO_CALL_INFO_ITEM]: {
      title: 'Видео-конференц-связь',
      getScrollElementId: (id: string) => getVideoCallInfoBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.VIDEO_CALL_INFO_ITEM_LINK]: {
      title: 'Видео-конференц-связь - Ссылка на видеосозвон',
      getScrollElementId: (id: string) => getVideoCallInfoBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.VIDEO_CALL_INFO_ITEM_DATE_TIME]: {
      title: 'Видео-конференц-связь - Дата и время проведения видеосозвона',
      getScrollElementId: (id: string) => getVideoCallInfoBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_RESULT_PRESCRIPTION]: {
      title: 'Соглашение - Предписание',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.prescription`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS]: {
      title: 'Соглашение - Нарушения, включенные в соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.violations`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATIONS]: {
      title: 'Соглашение - Нарушения, включенные в соглашение - Нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIX_FACT_METHOD]: {
      title: 'Соглашение - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES]: {
      title: 'Соглашение - Сведения о факте устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPES]: {
      title: 'Соглашение - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE]: {
      title: 'Соглашение - Тип материала',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    // [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION]: {
    //   title: 'Соглашение - Пояснение к материалу',
    //   getScrollElementId: (id: string) => getComplexDataBlockId(id),
    // },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION_REACT_QUILL_EDITOR]: {
      title: 'Соглашение - Пояснение к материалу',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },

    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_METHOD]: {
      title: 'Соглашение - Фактический способ устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES]: {
      title: 'Соглашение - Файлы устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES_VIDEO_LINK]: {
      title: 'Соглашение - Ссылка на файл устранения нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATIONS_VIOLATION_FIXES_GRADE]: {
      title: 'Соглашение - Оценка исправления нарушения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_TYPE]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Лицо, с которым заключается соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganizationType`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ATTACHMENT]: {
      title: 'Соглашение - Файл ходатайства',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionAttachment`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_INN]: {
      title: 'Соглашение - Ходатайство контролируемого лица - ИНН',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.inn`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_OGRN]: {
      title: 'Соглашение - Ходатайство контролируемого лица - ОГРН',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.ogrn`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_SNILS]: {
      title: 'Соглашение - Ходатайство контролируемого лица - СНИЛС',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.snils`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_SUBJECT_TYPE]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Тип контролируемого лица',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.subjectType`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_ORGANIZATION_NAME]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Наименование проверяемого лица',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.organizationName`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_PETITION_ORGANIZATION_ORGANIZATION_LOCATION_ADDRESS]: {
      title: 'Соглашение - Ходатайство контролируемого лица - Адрес места нахождения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.petitionOrganization.locationAddress`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVAL_OF_AGREEMENT]: {
      title: 'Соглашение - Решение об утверждении ходатайства',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approvalOfAgreement`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVAL_OF_AGREEMENT_ATTACHMENT]: {
      title: 'Соглашение - Файл решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approvalOfAgreementAttachment`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_ELIMINATE_VIOLATIONS_NUMBER]: {
      title: 'Соглашение - Соглашение об устранении нарушений',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.eliminateViolationsNumber`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CONCLUSION_DATE]: {
      title: 'Соглашение - Дата заключения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.conclusionDate`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_ELIMINATE_VIOLATIONS_ATTACHMENT]: {
      title: 'Соглашение - Файл соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.eliminateViolationsAttachment`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_COMPLETION_DATE]: {
      title: 'Соглашение - Срок исполнения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.termOfExecutionAgreement`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPLICATION_FOR_CONSIDERATION_ATTACHMENT]: {
      title: 'Соглашение - Заявление в органы прокуратуры о рассмотрении соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.applicationForConsiderationAttachment`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_VIOLATION_CORRECTION_PROGRAM_ATTACHMENTS]: {
      title: 'Соглашение - Программа устранения нарушений',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.violationCorrectionProgramAttachments`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_PROSECUTOR_ORGANIZATION]: {
      title: 'Соглашение - Наименование прокуратуры',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.prosecutorOrganization`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_NOTE]: {
      title: 'Соглашение - Комментарий',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.note`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_APPROVED]: {
      title: 'Соглашение - Решение по заявлению',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.approved`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_NUMBER_DECISION]: {
      title: 'Соглашение - Номер решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.numberDecision`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_DATE_DECISION]: {
      title: 'Соглашение - Дата решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.dateDecision`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_WHO_MADE_DECISION]: {
      title: 'Соглашение - Кем принято решение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.whoMadeDecision`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_TITLE_SIGNER]: {
      title: 'Соглашение - Должность лица, подписавшего решение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.titleSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_APPROVE_INFO_ATTACHMENT]: {
      title: 'Соглашение - Файл решения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.approveInfo.attachment`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_FIO_SIGNER]: {
      title: 'Соглашение - ФИО подписавшего соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.fioSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_TITLE_SIGNER]: {
      title: 'Соглашение - Должность лица, подписавшего соглашение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.titleSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TERMINATION_REASONS]: {
      title: 'Соглашение - Основания для признания соглашения неисполненным и расторжения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.terminationReasons`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TERMINATION_REASONS_ITEM]: {
      title: 'Соглашение - Основания для признания соглашения неисполненным и расторжения соглашения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_DECISION_TERMINATION_ATTACHMENT]: {
      title: 'Соглашение - Решение о признании соглашения неисполненным и расторжении соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.decisionTerminationAttachment`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_FIO_SIGNER]: {
      title: 'Соглашение - ФИО принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.fioSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TITLE_SIGNER]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.titleSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_TERMINATE_TITLE_SIGNER_LABEL]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.terminate.titleSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_DECISION]: {
      title: 'Соглашение - Решение об исполнении соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.decision`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_EXECUTION_DATE]: {
      title: 'Соглашение - Фактическая дата исполнения соглашения',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.executionDate`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_TITLE_SIGNER]: {
      title: 'Соглашение - ФИО принявшего решение',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.fioSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_EXECUTION_FIO_SIGNER]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => `${getAgreementsBlockId(id)}.execution.titleSigner`,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TYPES]: {
      title: 'Соглашение - Вид изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TYPES_ITEM]: {
      title: 'Соглашение - Вид изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_REASON]: {
      title: 'Соглашение - Основание для изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_REASON_ITEM]: {
      title: 'Соглашение - Основание для изменения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_ATTACHMENTS]: {
      title: 'Соглашение - Решение об изменении',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TERM_OF_EXECUTION_AGREEMENT]: {
      title: 'Соглашение - Новый срок исполнения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_UPDATED_AGREEMENT_ATTACHMENTS]: {
      title: 'Соглашение - Обновленная версия соглашения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_PETITION_ATTACHMENTS]: {
      title: 'Соглашение - Ходатайство об изменении соглашения',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_FIO_SIGNER]: {
      title: 'Соглашение - ФИО принявшего решение об изменении',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.AGREEMENT_CHANGE_TITLE_SIGNER]: {
      title: 'Соглашение - Должность принявшего решение об изменении',
      getScrollElementId: (id: string) => getComplexDataBlockId(id),
    },
    [KnmPmFormFieldsNamesTemplatesEnum.INTERACTION_CATEGORY]: {
      title: 'Сведения об использовании в рамках ПМ средств дистанционного взаимодействия с контролируемыми лицами',
      getScrollElementId: () => PM_FORM_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.NOTE_WARNING_REACT_QUILL_EDITOR]: {
      title: 'Описание предостережения',
      getScrollElementId: () => NOTE_WARNING_REACT_QUILL_EDITOR_BLOCK_ID,
    },
    [KnmPmFormFieldsNamesTemplatesEnum.SUBJECT_NOTIFICATIONS]: {
      title: 'Информация об уведомлении проверяемого лица о решении о проведении ПМ',
      getScrollElementId: () => KNM_NOTIFICATION,
    },
  };
};
